import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from 'react-polyglot';

import Link from '../Link';
import SvgIcon from '../SvgIcon';

import './Pill.scss';

class Pill extends Component {
  static defaultProps = {
    rpOffline: false
  }

  onSelect = () => {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick();
    }
    if (this.props.onTriggerEvents)
    {
      this.props.onTriggerEvents(this.props.label);
    }
  }

  render() {
    const baseClassName = 'pb-pill';

    const {
      label,
      onClose,
      icon,
      parentClassName,
      href,
      isInternal,
      isCategoryPill,
      onClick,
      isSelected,
      t,
      rpOffline,
      nonClickable,
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--dismissable`]: onClose,
      [`${baseClassName}--with-icon`]: icon,
      [`${baseClassName}--link`]: href,
      [`${baseClassName}--is-category-pill`]: isCategoryPill,
      [`${baseClassName}--selectable`]: onClick,
      [`${baseClassName}--selected`]: isSelected,
      [`${baseClassName}--rp-offline`]: rpOffline,
      [`${baseClassName}--no-click`]: nonClickable,
      [parentClassName]: parentClassName,
      [`${baseClassName}--survey-form`]: this.props.surveyForm
    }

    const parentElements = {
      span: 'span',
      link: Link
    }

    const Parent = parentElements[href ? 'link' : 'span'];

    return (
      <Parent
        className={href ? null : classNames(classes)}
        parentClassName={href ? classNames(classes) : null}
        isInternal={isInternal}
        onClick={this.onSelect}
        href={href}>
        {
          icon
          ?
          <SvgIcon parentClassName={`${baseClassName}__icon`} name={icon} title={icon === 'circle' ? null : t(`SvgTitle.${icon}`)} size="s" />
          :
          null
        }
        <span className={`${baseClassName}__label`}>{label}</span>
        {
          !href && onClose
          ?
          (
            <Link parentClassName={`${baseClassName}__link`} onClick={onClose}>
              <SvgIcon name="close-circle" title={t('SvgTitle.close-circle')} size="m" />
            </Link>
          )
          :
          null
        }
      </Parent>
    );
  }
}

Pill.propTypes = {
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  icon: PropTypes.string,
  parentClassName: PropTypes.string,
  href: PropTypes.string,
  isInternal: PropTypes.bool,
  isCategoryPill: PropTypes.bool
};

export default translate()(Pill);



// WEBPACK FOOTER //
// ./src/components/Pill/Pill.jsx